import * as _ from 'lodash';

export default function isNullOrUndefined(value: any): boolean {
  return value === null || _.isUndefined(value);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/isNullOrUndefined.ts